import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, forkJoin } from 'rxjs';
import { map } from "rxjs/operators";
import { MasterService } from '../masters/master.service';
import { LoaderService } from '../common/loader.service';

@Injectable()
export class PatientResolver implements Resolve<Observable<any>> {

  constructor(private masterService: MasterService, private loaderService: LoaderService) { }

  resolve(): Observable<any> {
    return forkJoin(
      this.masterService.getOrganisms(),
      this.masterService.getGender()
    ).pipe(
      map(
        ([
          organisms,
          genderList
        ]) => {
          return {
            organisms,
            genderList
          };
        }
      )
    );
  }
}
